import React from "react";
import parse from "html-react-parser";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface OfferLetterViewPanelProps {
  isOpen: boolean;
  onClose: () => void;
  offerLetterContent: string;
  jobTitle: string;
  status?: number;
}

export default function OfferLetterViewPanel({
  isOpen,
  onClose,
  offerLetterContent,
  jobTitle,
  status,
}: OfferLetterViewPanelProps) {
  const { t } = useTranslation("job-details");

  if (!isOpen) {
    return null;
  }

  // Format text to handle line breaks
  const formatOfferLetterContent = (content: string) => {
    if (!content) return "";
    return parse(content);
  };

  return (
    <div className="offer-preview-panel-overlay" onClick={onClose}>
      <div className="offer-preview-panel" onClick={(e) => e.stopPropagation()}>
        <div className="offer-preview-header">
          <h3>{t("jobDetails.finalDecision.offerStatus.viewOffer")}</h3>
          <p>
            {t("jobDetails.finalDecision.previewPanel.for")} {jobTitle}
          </p>
          <button className="close-panel" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="offer-preview-content">
          {/* Status Banner */}
          {status === 7 && (
            <div
              className="offer-status-banner"
              style={{
                backgroundColor: "#dcfce7",
                color: "#15803d",
                padding: "12px 20px",
                borderLeft: "4px solid #22c55e",
                marginBottom: "16px",
              }}
            >
              <strong>{t("jobDetails.finalDecision.offerStatus.offerAccepted")}</strong>
            </div>
          )}
          {status === 8 && (
            <div
              className="offer-status-banner"
              style={{
                backgroundColor: "#fee2e2",
                color: "#991b1b",
                padding: "12px 20px",
                borderLeft: "4px solid #ef4444",
                marginBottom: "16px",
              }}
            >
              <strong>{t("jobDetails.finalDecision.offerStatus.offerRejected")}</strong>
            </div>
          )}

          <div className="offer-details">{formatOfferLetterContent(offerLetterContent)}</div>
        </div>
      </div>
    </div>
  );
}
